const navbar = {
  packages: "Pacotes", // translated
  experiences: "Experiências", // translated
  close: "Perto", // translated
  dashboard: "Painel", // translated
  pricing: "Preços", // translated
  hotDeals: "Ofertas quentes", // translated
  hotelPackages: "Pacotes de hotéis", // translated
};

export default navbar;
